export const getExperienceRowState = ({
  currentExperience = {},
  index,
  selectedIndex,
  isCurrentlyWorkingValue,
  wasCurrentlyWorkingBefore = false,
}) => {
  const isSelectedRow = index === selectedIndex;
  const isEditedFromYesToNo = isSelectedRow
    ? wasCurrentlyWorkingBefore && isCurrentlyWorkingValue === false
    : Boolean(currentExperience?.isEditedFromYesToNo);

  return {
    isCurrentlyWorking: isSelectedRow ? isCurrentlyWorkingValue : false,
    isEditable: isSelectedRow || isEditedFromYesToNo,
    isEditedFromYesToNo,
  };
};

export const shouldDisableToDateField = ({
  experience = {},
  hasCurrentOrganisation = false,
  isSubmitted = false,
}) => {
  const isEditable = experience.isEditable ?? true;
  const isLockedByCurrentOrganisation =
    hasCurrentOrganisation && !experience.isEditedFromYesToNo;

  return (
    experience.isCurrentlyWorking ||
    isSubmitted ||
    isLockedByCurrentOrganisation ||
    !isEditable
  );
};
